module.exports = __webpack_public_path__ + "img/dispatched.def706ad.svg";